<template>
  <div id="diy-dialog-exam-details">
    <!-- 查看考试详情--数据概览 -->
    <div class="line">
      <div class="title">
        <div class="sh"></div>
        考试基本信息
      </div>
      <div class="xx">
        <div class="title">主题:</div>
        <div class="value">{{ data.name }}</div>
      </div>
      <div class="xx">
        <div class="x1">
          <div class="title">状态:</div>
          <div class="value">{{ data.status }}</div>
        </div>
        <div class="x1">
          <div class="title">考试时间:</div>
          <div class="value">{{ data.examTime }}</div>
        </div>
        <div class="x1">
          <div class="title">阅卷老师:</div>
          <div class="value">{{ data.readOverName }}</div>
        </div>
      </div>
    </div>

    <div class="line">
      <div class="title">
        <div class="sh"></div>
        考试分布
      </div>
      <div class="chart">
        <el-radio-group v-model="stage" @change="getTestPersonList">
          <el-radio
            :label="item.value"
            v-for="(item, index) in stageList"
            :key="index"
            >{{ item.label }}</el-radio
          >
        </el-radio-group>
        <el-table :data="tableData" stripe style="width: 100%" height="100%">
          <el-table-column
            :prop="menu.key"
            :label="menu.name"
            v-for="(menu, index) in personMenu"
            :key="index"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="line">
      <div class="title">
        <div class="sh"></div>
        数据概览
      </div>
      <div class="chart">
        <div id="examChart"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "div_dialog_eaxm_details",
  props: {
    examId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      id: this.examId,
      data: {
        name: "考试主题主题主题",
        status: "待发布",
        examTime: "2023-05-01 14:00:00",
        readOverName: "张老师",
      },
      personMenu: this.$systemBaseData.getTableMenuData("examPersonDetails"),
      tableData: [],
      stage: 0,
      stageList: [
        { value: 0, label: "不及格" },
        { value: 1, label: "及格" },
        { value: 2, label: "良好" },
        { value: 3, label: "优秀" },
      ],
    };
  },
  watch: {
    examId() {
      this.id = this.examId;
    },
    data(newValue) {
      this.$emit("showExamId", this.id);
    },
  },
  methods: {
    /**
     * 根据考试ID,查看当前考试详情
     */
    async getExamDetails() {
      try {
        let resultData = await this.$request({
          url: "/exam/showExamDetails",
          method: "post",
          data: { id: this.id },
        });
        this.data = resultData;
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 查看本场考试的人员分布情况
     */
    async getTestPersonList() {
      try {
        let resultData = await this.$request({
          url: "/teacherExam/getAllExamUserList",
          method: "post",
          data: { stage: this.stage, examId: this.id },
        });
        this.tableData = resultData;
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 根据考试ID,查询当场考试的成绩分布
     */
    async examScore() {
      try {
        let resultData = await this.$request({
          url: "/statistics/examScore",
          method: "post",
          data: { examId: this.id },
        });
        let data = [
          { value: 1048, name: "不及格(低于60%)", key: "fail" },
          { value: 735, name: "及格(60%-75%)", key: "pass" },
          { value: 580, name: "良好(75%-85%)", key: "good" },
          { value: 484, name: "优秀(85%-100%)", key: "excellent" },
        ];
        data.forEach((element) => {
          element.value = resultData[element.key];
        });
        let examChart = this.$echarts.init(
          document.getElementById("examChart")
        );
        let option = {
          title: {
            text: this.data.name,
            subtext: "成绩分布图",
            left: "center",
          },
          tooltip: {
            trigger: "item",
          },
          legend: {
            orient: "vertical",
            left: "left",
          },
          series: [
            {
              name: "人数",
              type: "pie",
              radius: "50%",
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
        };
        examChart.setOption(option);
      } catch (error) {
        this.$message.error(error.message);
      }
    },
  },
  async mounted() {
    await this.getExamDetails();
    await this.examScore();
    await this.getTestPersonList();
  },
};
</script>

<style lang="less" scoped>
#diy-dialog-exam-details {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  .title {
    width: 100%;
    height: 35px;
    display: flex;
    align-items: center;
    font-size: 15px;
    font-weight: bold;
    padding: 0 20px;
    box-sizing: border-box;
    > .sh {
      width: 4px;
      height: 15px;
      background-color: @baseColor;
      margin-right: 10px;
      margin-top: 2px;
    }
  }
  > .line {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
    > .xx {
      width: 100%;
      display: flex;
      align-items: center;
      > .x1 {
        width: 0;
        flex: 1;
        display: flex;
      }
      .title {
        width: 110px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
      .value {
        width: 0;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-size: 14px;
      }
    }
    > .chart {
      width: 100%;
      height: 400px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
    }
  }
  #examChart {
    width: 100%;
    height: 100%;
  }
}
</style>